/*
  Na het laden nog één keer naar het anker in de URL scrollen.

  Waarom: getground.nl/review (de QR-code op de insteekkaart) leidt om naar
  /products/kabelmat#judgeme_product_reviews. De browser scrolt naar dat anker zodra de HTML er
  staat, maar daarna verandert de hoogte van de pagina nog: het reviewblok van Judge.me wordt pas
  na het laden getekend. Gemeten op 5 okt 2026: op mobiel kwam de bezoeker 288 px voorbij het
  reviewblok uit, midden in de sectie eronder.

  Raakt de bezoeker de pagina zelf aan (scrollen, tikken, toets), dan blijven we eraf: een pagina
  die onder je vinger wegspringt is erger dan een anker dat net niet klopt.
*/
(function () {
  if (!window.location.hash || window.location.hash.length < 2) return;

  var id;
  try {
    id = decodeURIComponent(window.location.hash.slice(1));
  } catch (e) {
    return;
  }

  var aangeraakt = false;
  function stop() {
    aangeraakt = true;
  }
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (naam) {
    window.addEventListener(naam, stop, { once: true, passive: true });
  });

  function naarAnker() {
    if (aangeraakt) return;
    var doel = document.getElementById(id);
    if (doel) doel.scrollIntoView({ block: 'start' });
  }

  function plan() {
    naarAnker();
    window.setTimeout(naarAnker, 500);
    window.setTimeout(naarAnker, 1500);
  }

  if (document.readyState === 'complete') {
    plan();
  } else {
    window.addEventListener('load', plan, { once: true });
  }
})();
